import React from "react";
import DropDownSelect from "../../common/DropDownSelect";
import PropTypes from "prop-types";

export default function Reoccurring({
  frequency,
  specs,
  selected,
  setSelected,
  selectedSpec,
  setSelectedSpec,
  startdate,
  setFinalDate,
  isChecked,
  setIsChecked
}) {
  function handleOnCheck() {
    setIsChecked(!isChecked);
  }

  return (
    <div className="reoccurring">
      <div className="reoccurring-checkbox">
        <input
          type="checkbox"
          name="occurrances"
          id="occurrances"
          checked={isChecked}
          onChange={handleOnCheck}
        />
        <span> Upprepa </span>
      </div>
      {isChecked && (
        <>
          <DropDownSelect
            choices={frequency}
            selected={selected}
            onChange={setSelected}
          />
            <span className="final-time-label">fram till </span>
            <input className="final-time-input"
              type="date"
              name="finalDate"
              min={startdate}
              defaultValue={
                startdate
                  ? startdate.substring(0, 10)
                  : new Date().toLocaleString().substring(0, 10)
              }
              onChange={setFinalDate}
            ></input>
          {selected === "varje månad" && (
            <div className="spec">
              <DropDownSelect
                choices={specs}
                selected={selectedSpec}
                onChange={setSelectedSpec}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

Reoccurring.propTypes = {
  frequency: PropTypes.array.isRequired,
  specs: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired,
  selectedSpec: PropTypes.string.isRequired,
  setSelectedSpec: PropTypes.func.isRequired,
  startdate: PropTypes.string,
  finalDate: PropTypes.string,
  setFinalDate: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func
};
